import { useTranslations } from 'next-intl';
import Image from 'next/image';

interface PreviewUnavailableProps {
  thumbnailUrl: string;
  width: number;
  height: number;
}

export const PreviewUnavailable = ({ thumbnailUrl, width, height }: PreviewUnavailableProps) => {
  const tErrors = useTranslations('errors');

  return (
    <div className="relative" data-cy="preview-unavailable">
      <Image src={thumbnailUrl} alt="" width={width} height={height} className="opacity-50 blur-lg" />
      <div className="pointer-events-none absolute inset-0 z-20 flex items-center justify-center">
        <p className="font-medium text-text-base" data-cy="preview-unavailable-message">
          {tErrors('previewNotAvailable')}
        </p>
      </div>
    </div>
  );
};
